<app-page-meta pageTitle="finzy - Loan Application Status"></app-page-meta>
<app-header></app-header>

<div class="container-fluid full-height center-children">
  <div class="row">
    <div class="col-xs-12 text-center">
      <span><img class="my-3" src="../../../assets/images/application-status/time-left.svg"/></span>

      <h1 class="heading small-heading">{{ progressDescription?.heading }}</h1>
      <p class="small-heading color-finzy-dark-blue">{{ progressDescription?.subheading }}</p>

      <p>{{ progressDescription?.description }}<br/>
        We will send you an update within <b>1 business day</b> on your registered phone number and email address.</p>

      <div class="row">
        <div class="col-xs-10 col-xs-offset-1 my-5 py-3">

          <!-- TODO Implement an 'active' directive to just set a milestone to Active and the others to proper states -->

          <app-progress-bar [nextMilestoneName]="applicationProgress.getNextMilestoneLabel()">
            <app-milestone>{{ applicationProgress.getLabelForMilestone(ProgressMilestones.ApplicationSubmission) }}</app-milestone>
            <app-milestone>{{ applicationProgress.getLabelForMilestone(ProgressMilestones.KycVerification) }}</app-milestone>
            <app-milestone>{{ applicationProgress.getLabelForMilestone(ProgressMilestones.OfferAcceptance) }}</app-milestone>
            <app-milestone>{{ applicationProgress.getLabelForMilestone(ProgressMilestones.LoanFulfilment) }}</app-milestone>
            <app-milestone>{{ applicationProgress.getLabelForMilestone(ProgressMilestones.LoanDisbursal) }}</app-milestone>
          </app-progress-bar>
        </div>
      </div>

      <p>If you need assistance, you can read our <a class="refrem" target="_blank" [routerLink]="['/faq']">FAQs</a>.
        You can even call us on <span class="d-inline-block">9341 300 300</span>. We are always happy to help!</p>
    </div>
  </div>
</div>

<app-footer></app-footer>
